export default __webpack_public_path__ + "static/media/christ-embassy.3900e387.png";